<template>
	<section v-closable="onClose_ClickHandler" class="sk-action-group" :class="['sk-action-group', { 'sk-action-group--has-button': hasButton, 'sk-action-group--active': isActive, 'sk-action-group--open': isOpen }]">
		<header @click="onOpen_ClickHandler" class="sk-action-group__header"></header>
		<main ref="container" class="sk-action-group__content">
			<slot></slot>
		</main>
	</section>
</template>

<script>
import Closable from '@/directives/Closable'
export default {
	name: 'action-group',
	directives: {
		Closable
	},
	props: {
		hasButton: {
			type: Boolean,
			default: false
		}
	},
	data() {
		return {
			isOpen: false,
			isActive: false,
			observerMutation: {
				config: { attributes: false, childList: true, subtree: false },
				obj: null
			}
		}
	},
	methods: {
		updateActive() {
			this.isActive = this.$refs.container && this.$refs.container.children.length > 0
		},
		onOpen_ClickHandler() {
			this.isOpen = !this.isOpen
		},
		onClose_ClickHandler() {
			this.isOpen = false
		}
	},
	mounted() {
		this.observerMutation.obj.observe(this.$refs.container, this.observerMutation.config);
		this.updateActive()
	},
	created() {
		this.observerMutation.obj = new MutationObserver(this.updateActive)
		this.$on('close', this.onClose_ClickHandler)
	},
	destroyed() {
		if (this.observerMutation.obj) {
			this.observerMutation.obj.disconnect()
		}
		this.$off('close', this.onClose_ClickHandler)
	}
}
</script>

<style>
.sk-action-group {
	position: relative;
	display: none;
}
.sk-action-group.sk-action-group--active {
	display: block;
}
.sk-action-group__header {
	height: 30px;
	width: 30px;
	display: flex;
	align-items: center;
	justify-content: center;
	padding: 0 10px;
	font-size: 12px;
	text-decoration: none;
	background-image: url(/static/svg/buttons/show-more-button-with-three-dots.svg);
	background-position: center;
	background-repeat: no-repeat;
	background-size: 15px 15px;
	cursor: pointer;
	background-color: rgba(0,0,0,0);
	transition: background-color 0.3s;
}
.sk-action-group__header:hover {
	background-color: rgba(0,0,0,0.05);
}
.sk-action-group.sk-action-group--has-button .sk-action-group__header {
	background-color: #fff;
	height: 35px;
	width: 35px;
	display: flex;
	justify-content: center;
	align-items: center;
	padding: 0;
	border-radius: 3px;
	box-shadow: rgba(0,0,0,0.1) 1px 1px 5px;
}
.sk-action-group.sk-action-group--has-button .sk-action-group__header:hover {
	background-color: rgba(0,0,0,0.05);
}
.sk-action-group__content {
	z-index: 999;
	position: absolute;
	right: 15px;
	top: 40px;
	min-width: 200px;
	opacity: 0;
	transform: translate(0, 20px);
	transition: all 300ms;
	background: #fff;
	box-shadow: rgba(0,0,0,0.1) 1px 1px 5px;
	padding: 0;
	clip-path: inset(0 0 100% 0);
}
.sk-action-group.sk-action-group--has-button .sk-action-group__content {
	top: 45px;
	right: 0;
}
.sk-action-group.sk-action-group--open .sk-action-group__content {
	clip-path: inset(-10px -10px -10px -10px);
	opacity: 1;
	transform: translate(0, 0);
}
</style>



// WEBPACK FOOTER //
// src/modules/ui/ActionGroup.vue